import { render, staticRenderFns } from "./DataCorrectionTaskLevel2.vue?vue&type=template&id=342c2250&scoped=true&"
import script from "./DataCorrectionTaskLevel2.vue?vue&type=script&lang=js&"
export * from "./DataCorrectionTaskLevel2.vue?vue&type=script&lang=js&"
import style0 from "./DataCorrectionTaskLevel2.vue?vue&type=style&index=0&id=342c2250&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "342c2250",
  null
  
)

export default component.exports